import App from './root.loader';

export default App;
